import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\DropdownMenu.tsx.esbuild-plugin-linaria.css';
import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\DropdownMenu.tsx.esbuild-plugin-windicss.css';
import { css, cx } from '@linaria/core';
import { memo } from 'preact/compat';
import { useEffect, useRef } from 'preact/hooks';
import { Icon } from './Icon';
export interface MenuItemModel {
  readonly icon?: string;
  readonly label?: string;
  readonly children?: preact.ComponentChildren;
  readonly link?: string;
  readonly newTab?: boolean;
  readonly active?: boolean;
  readonly disabled?: boolean;
  readonly onClick?: () => unknown;
}
export const menuItemSeparator: MenuItemModel = {
  label: ''
};
export const menuItemSeparatorElement = <hr class={"hkrk27n"} />;
export const dropdownMenuItemCssClass = "d1suuw2w";
const DropdownMenuItem = ({
  item,
  className,
  setOpen
}: {
  item: MenuItemModel;
  className?: string;
  setOpen: (isOpen: boolean) => void;
}) => <li>
    <a href={item.link} target={item.link && item.newTab ? '_blank' : undefined} rel="noopener noreferrer" onClick={() => {
    item.onClick?.();
    setOpen(false);
  }} className={cx(className, item.active && 'pointer-events-none !text-primary font-bold', item.disabled && 'pointer-events-none opacity-30', dropdownMenuItemCssClass)}>
      {item.icon && <Icon icon={item.icon} size={20} className={"i1tuq91o"} />}
      {item.label && <span data-text={item.label}>{item.label}</span>}
      {item.children}
    </a>
  </li>;
const setMenuHeight = (element: HTMLElement) => element.style.maxHeight = `${window.innerHeight - element.getBoundingClientRect().top - 32}px`;
const menuHeightSettingObserver = new IntersectionObserver(entries => entries.forEach(entry => setMenuHeight(entry.target as HTMLElement)));
export const useDropdownMenuHeightSetting = (ref: React.RefObject<HTMLElement>) => useEffect(() => {
  const element = ref.current!;
  const onResize = () => setMenuHeight(element);
  addEventListener('resize', onResize);
  menuHeightSettingObserver.observe(element);
  return () => {
    menuHeightSettingObserver.unobserve(element);
    removeEventListener('resize', onResize);
  };
}, [ref]);
export const DropdownMenu = memo(({
  itemClass,
  items,
  setOpen
}: {
  itemClass?: string;
  items: readonly MenuItemModel[];
  setOpen: (isOpen: boolean) => void;
}) => {
  const ref = useRef<HTMLUListElement>(null);
  useDropdownMenuHeightSetting(ref);
  return <ul ref={ref} class="p-0 whitespace-nowrap overflow-auto">
        {items.map(item => item === menuItemSeparator ? menuItemSeparatorElement : <DropdownMenuItem key={item.label} item={item} className={itemClass} setOpen={setOpen} />)}
      </ul>;
});